/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { AddCircle, Clear, Delete, Edit, Search } from "@mui/icons-material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogEdit from "./modal/dialogEdit";
import React from "react";
import messages from "../../../utils/messages";
import serviceParametrizacao from "../../../services/serviceParametrizacao";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import IGenericResult from "@/interfaces/IGenericResult";
import DialogNew from "./modal/dialogNew";
import { habilitadoFilterOptions, habilitadoOptions } from "@/utils/constants";
import { DialogDelete } from "./modal/dialogDelete";

const Parametros: React.FC = () => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Cadastro - Parâmetros");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [filters, setFilters] = useState({ habilitado: "Sim" });
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [contextoDataOptions, setContextoDataOptions] = useState<any[]>([]);
    const [openModalAdd, setOpenModalAdd] = useState<boolean>(false);
    const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
    const [deleteState, setDeleteState] = useState({ id: "", global: false });
    const [nomeParametroOptions, setNomeParametroOptions] = useState<any[]>([]);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [editState, setEditState] = useState({
        open: false,
        campoAberto: "",
        contexto: "",
        descricao: "",
        nomeParametro: "",
        parametrizacaoID: 0,
        tipo: "",
        valor: "",
        valoresPossiveis: "",
        nomeConcessionaria: "",
        concessionariaID: 0,
    });
    const [isLoading, setLoading] = useState(false);

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operação",
                field: "operations",
                type: "actions",
                width: 160,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() => {
                            setEditState({
                                open: true,
                                campoAberto: params.row.campoAberto,
                                contexto: params.row.contexto,
                                descricao: params.row.descricao,
                                nomeParametro: params.row.nomeParametro,
                                parametrizacaoID: params.row.parametrizacaoID,
                                tipo: params.row.tipo,
                                valor: params.row.valor,
                                valoresPossiveis: params.row.valoresPossiveis,
                                nomeConcessionaria: params.row.nomeConcessionaria,
                                concessionariaID: params.row.concessionariaID,
                            });
                        }}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        disabled={params.row.habilitado === "Não"}
                        onClick={() => {
                            setDeleteState({
                                id: "",
                                global: false,
                            });
                            setOpenModalDelete(true);
                            setDeleteState({
                                id: params.row.parametrizacaoID.toString(),
                                global: params.row.nomeConcessionaria === null,
                            });
                        }}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "parametrizacaoID",
                type: "number",
                headerAlign: "left",
                identity: true,
                id: 70,
                flex: 1,
            },
            {
                headerName: "Nome",
                field: "nomeParametro",
                type: "string",
                minWidth: 500,
                flex: 1,
            },
            {
                headerName: "Valor atual",
                field: "valor",
                type: "string",
                minWidth: 130,
                flex: 1,
            },
            {
                headerName: "Contexto",
                field: "contexto",
                type: "string",
                minWidth: 120,
                flex: 1,
            },
            {
                headerName: "Descrição",
                field: "descricao",
                type: "string",
                minWidth: 600,
                flex: 1,
            },
            {
                headerName: "Concessionária",
                field: "nomeConcessionaria",
                type: "string",
                minWidth: 350,
                flex: 1,
            },
            {
                headerName: "Habilitado",
                field: "habilitado",
                type: "string",
                minWidth: 100,
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            contexto: "",
            nomeParametro: "",
            habilitado: "Sim",
            concessionariaID: "",
        },
    });

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const setContextoData = async () => {
        serviceParametrizacao
            .getContextos()
            .then((result) =>
                setContextoDataOptions(
                    result?.data.map((contexto) => {
                        return { label: contexto, value: contexto };
                    })
                )
            )
            .catch(() => {
                setContextoDataOptions([]);
            });
    };

    const setNomeParametroData = async () => {
        serviceParametrizacao
            .getNomes()
            .then((result) =>
                setNomeParametroOptions(
                    result?.data.map((data) => {
                        return { label: data.nomeParametro, value: data.nomeParametro };
                    })
                )
            )
            .catch(() => {
                setNomeParametroOptions([]);
            });
    };

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceParametrizacao
            .getWithFilter({
                ...filters,
                habilitado: habilitadoFilterOptions[filters.habilitado],
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            setConcessionariaData();
            setContextoData();
            setNomeParametroData();
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const onSubmit = (values: any) => {
        setFilters(values);
        getAllWithFilters(values);
    };

    const onClear = () => {
        reset({ concessionariaID: "", contexto: "", habilitado: "", nomeParametro: "" });
        getAllWithFilters({ concessionariaID: "", contexto: "", habilitado: "", nomeParametro: "" });
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    const handleCloseDelete = () => {
        setOpenModalDelete(false);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <AutoComplete
                                        id="concessionariaID"
                                        name="concessionariaID"
                                        label="Concessionária"
                                        options={concessionariaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="contexto"
                                        name="contexto"
                                        label="Contexto"
                                        options={contextoDataOptions ?? []}
                                        control={control}
                                        error={errors}
                                        concatWithID={false}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ marginTop: "5px" }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Button
                                                id="pesquisar"
                                                startIcon={<Search />}
                                                disableElevation
                                                type="submit"
                                                fullWidth
                                                variant="contained"
                                                color="warning"
                                            >
                                                pesquisar
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Button
                                                id="novo"
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={() => setOpenModalAdd(true)}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} display="flex" alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <AutoComplete
                                        id="nomeParametro"
                                        name="nomeParametro"
                                        label="Parâmetro"
                                        options={nomeParametroOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <AutoComplete
                                        id="habilitado"
                                        name="habilitado"
                                        label="Habilitado"
                                        options={habilitadoOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4} sx={{ marginTop: "5px" }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <Button
                                                id="limpar"
                                                startIcon={<Clear />}
                                                disableElevation
                                                onClick={() => onClear()}
                                                fullWidth
                                                variant="outlined"
                                                color="warning"
                                            >
                                                limpar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.parametrizacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogNew
                        open={openModalAdd}
                        data={{
                            concessionariaDataOptions,
                            contextoOptions: contextoDataOptions ?? [],
                        }}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            setOpenModalAdd(false);
                        }}
                    />

                    <DialogEdit
                        props={{ ...editState, concessionariaDataOptions }}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            setEditState({
                                open: false,
                                campoAberto: "",
                                contexto: "",
                                descricao: "",
                                nomeParametro: "",
                                parametrizacaoID: 0,
                                tipo: "",
                                valor: "",
                                valoresPossiveis: "",
                                nomeConcessionaria: "",
                                concessionariaID: 0,
                            });
                        }}
                    />

                    <DialogDelete
                        open={openModalDelete}
                        data={deleteState}
                        onClose={handleCloseDelete}
                        onSuccess={onSuccessAction}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default Parametros;
